import { useSyncExternalStore } from 'react';

// Upload requests continue across Admin Console section changes. Keep their
// activity outside mounted panels so returning cannot enable Go prematurely.
const activeUploads = new Map<string, number>();
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(listener => listener());
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

/** Track one upload until its requests settle, even if its panel unmounts. */
export function beginMigrationUpload(organizationId: string): () => void {
  activeUploads.set(organizationId, (activeUploads.get(organizationId) ?? 0) + 1);
  notify();
  let finished = false;
  return () => {
    if (finished) return;
    finished = true;
    const remaining = (activeUploads.get(organizationId) ?? 1) - 1;
    if (remaining === 0) activeUploads.delete(organizationId);
    else activeUploads.set(organizationId, remaining);
    notify();
  };
}

/** Observe all uploads for this organization across mounted and hidden panels. */
export function useMigrationUploadActivity(organizationId: string): boolean {
  return useSyncExternalStore(subscribe, () => (activeUploads.get(organizationId) ?? 0) > 0, () => false);
}
